import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from '../Sidebar/Sidebar';
import Navbar from '../Navbar/Navbar';
import NewInput from '../NewInput/NewInput';
import DynamicLoader from '../../Images/DynamicLoader';
import { categoryAPI, fileAPI } from '../../services/apiService';
import './categoryForm.css';

function CategoryForm() {
    const navigate = useNavigate();

    const [form, setForm] = useState({
        title: '',
        priority: 100,
        icon: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.title) {
            alert(t('required_category_name'));
            return;
        }

        if (!form.icon) {
            alert(t('required_icon'));
            return;
        }

        try {
            const selectedIcon = DynamicLoader.find((icon) => icon.key === form.icon);

            if (!selectedIcon) {
                alert(t('invalid_icon'));
                return;
            }

            const iconFile = await fileAPI.getSvgFileFromUrl(selectedIcon.url, `${form.icon}.svg`);

            const formData = new FormData();
            formData.append('title', form.title);
            formData.append('priority', form.priority);
            formData.append('image', iconFile);

            await categoryAPI.create(formData);

            navigate('/categories', {
                state: { successMessage: t('category_added_success') },
            });
        } catch (error) {
            console.error(error);
            alert(t('submit_error'));
        }
    };

    return (
        <div className="add_category_page">
            <div className="categories_sidebar">
                <Sidebar />
            </div>

            <div className="add_category_main">
                <Navbar />

                <div className="form_wrapper">
                    <h2>{t('add_category')}</h2>

                    <form onSubmit={handleSubmit}>
                        <NewInput
                            name="title"
                            label={t('category_name')}
                            type="text"
                            placeholder={t('category_name_placeholder')}
                            required
                            value={form.title}
                            onChange={handleChange}
                        />

                        <NewInput
                            name="priority"
                            label={t('priority')}
                            type="number"
                            value={form.priority}
                            onChange={handleChange}
                        />

                        <div className="icon-selection">
                            <span className="icon-label">{t('select_icon')}</span>

                            <div className="icon-grid">
                                {DynamicLoader.map((icon) => {
                                    const isActive = form.icon === icon.key;
                                    return (
                                        <button
                                            type="button"
                                            key={icon.key}
                                            className={`icon-item ${isActive ? 'active' : ''}`}
                                            onClick={() =>
                                                setForm((prev) => ({
                                                    ...prev,
                                                    icon: icon.key,
                                                }))
                                            }
                                            aria-pressed={isActive}
                                        >
                                            <img src={icon.url} alt={icon.key} />
                                        </button>
                                    );
                                })}
                            </div>
                            {!form.icon && <span className="icon-hint">{t('icon_hint')}</span>}
                        </div>

                        <button type="submit" className="submit_btn">
                            {t('submit_category')}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CategoryForm;
